import { ElementRef } from '@angular/core';
var ComponentProgressBar = (function () {
    function ComponentProgressBar(el) {
        this.el = el;
        this.progress = 0; //进度
        this.isShowInner = false;
        this.isShowRedDot = false;
    }
    ComponentProgressBar.prototype.ngOnInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.renderOnInit();
        }, 500);
    };
    ComponentProgressBar.prototype.ngOnChanges = function () {
        var _this = this;
        setTimeout(function () {
            _this.renderOnInit();
        }, 500);
    };
    //初始化渲染
    ComponentProgressBar.prototype.renderOnInit = function () {
        var _this = this;
        if (this.type === 'circle') {
            this.x = this.theme.x ? this.theme.x : 0;
            this.y = this.theme.y ? this.theme.y : 0;
            this.radius = this.theme.radius ? this.theme.radius : 90;
            this.thickness = this.theme.thickness ? this.theme.thickness : 20;
            this.innerRadius = this.radius - this.thickness;
            this.startAngle = this.theme.startAngle ? this.theme.startAngle : 0;
            this.endAngle = this.theme.endAngle ? this.theme.endAngle : 360;
            this.canvas = this.el.nativeElement.querySelector('#tutorial');
            this.canvas.width = this.theme.width ? this.theme.width : 300;
            this.canvas.height = this.theme.height ? this.theme.height : 300;
            this.ctx = this.canvas.getContext('2d');
            this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2); //将绘图原点移到画布中央
            var angleRadian = this.theme.angleRadian ? this.theme.angleRadian : 275;
            this.ctx.rotate(this.angle2Radian(angleRadian)); //将画布旋转275度
            this.ctx.fillStyle = "#eee"; //初始填充颜色
            this.renderRing(this.startAngle, this.endAngle);
            //进度条颜色 (下标为4的是透明色，下标0-3是填充色，单色设置一样即可)
            var lingrad = this.ctx.createLinearGradient(0, 0, 150, 150);
            var colors = this.theme.colors ? this.theme.colors : ['#FFF', '#000'];
            if (this.progress === 100) {
                colors = [this.theme.colors[2], this.theme.colors[3]];
            }
            else if (this.progress === 0) {
                colors = [this.theme.colors[4], this.theme.colors[4]];
            }
            lingrad.addColorStop(0, colors[0]);
            lingrad.addColorStop(1, colors[1]);
            this.ctx.fillStyle = lingrad;
            //开始绘画
            var tempAngle_1 = this.startAngle;
            var total = 100; //总分
            var now = this.progress === 100 && this.progress > 3 ? this.progress : this.progress - 3; //当前分数
            var percent = now / total; //百分比
            var twoEndAngle_1 = percent * 360 + this.startAngle;
            var step_1 = (twoEndAngle_1 - this.startAngle) / 80;
            var numberSpan = this.el.nativeElement.querySelector('.number');
            // let numberSpan = document.querySelector('.number');
            var inter_1 = setInterval(function () {
                if (tempAngle_1 > twoEndAngle_1) {
                    clearInterval(inter_1);
                    _this.isShowRedDot = true;
                }
                else {
                    // numberSpan.innerText = percent * 100;
                    tempAngle_1 += step_1;
                }
                _this.renderRing(_this.startAngle, tempAngle_1);
            }, 10);
        }
        else if (this.type === 'bar' && this.isShowBar) {
            var target = this.el.nativeElement.querySelector('.progress-inner');
            var mark = this.el.nativeElement.querySelector('.progress-inner-mark');
            mark.style.left = this.progress > 3 ? this.progress - 3 + '%' : this.progress + '%';
            target.style.width = this.progress + '%';
            target.style.backgroundColor = this.theme.color;
            target.style.borderRadius = this.theme.radius;
        }
    };
    //渲染函数
    ComponentProgressBar.prototype.renderRing = function (startAngle, endAngle) {
        this.ctx.beginPath();
        //绘制外环
        this.ctx.arc(this.x, this.y, this.radius, this.angle2Radian(startAngle), this.angle2Radian(endAngle));
        //计算外环与内环第一个连接处的中心坐标
        var oneCtrlPoint = this.calcRingPoint(this.x, this.y, this.innerRadius + this.thickness / 2, endAngle);
        //绘制外环与内环第一个连接处的圆环
        this.ctx.arc(oneCtrlPoint.x, oneCtrlPoint.y, this.thickness / 2, this.angle2Radian(-90), this.angle2Radian(270));
        //绘制内环
        this.ctx.arc(this.x, this.y, this.innerRadius, this.angle2Radian(endAngle), this.angle2Radian(startAngle), true);
        //计算外环与内环第二个连接处的中心坐标
        var twoCtrlPoint = this.calcRingPoint(this.x, this.y, this.innerRadius + this.thickness / 2, startAngle);
        //绘制外环与内环第二个连接处的圆环
        this.ctx.arc(twoCtrlPoint.x, twoCtrlPoint.y, this.thickness / 2, this.angle2Radian(-90), this.angle2Radian(270));
        this.ctx.fill();
        // ctx.stroke()
    };
    //计算圆环上点的坐标
    ComponentProgressBar.prototype.calcRingPoint = function (x, y, radius, angle) {
        var res = {
            x: x + radius * Math.cos(angle * Math.PI / 180),
            y: y + radius * Math.sin(angle * Math.PI / 180)
        };
        return res;
    };
    //弧度转角度
    ComponentProgressBar.prototype.radian2Angle = function (radian) {
        return 180 * radian / Math.PI;
    };
    //角度转弧度
    ComponentProgressBar.prototype.angle2Radian = function (angle) {
        return angle * Math.PI / 180;
    };
    ComponentProgressBar.prototype.ngAfterViewInit = function () {
    };
    return ComponentProgressBar;
}());
export { ComponentProgressBar };



// WEBPACK FOOTER //
// ./src/component-ui/progress-bar/component.progressBar.ts.pre-build-optimizer.js